import { render, staticRenderFns } from "./searchTournamentsContent.vue?vue&type=template&id=ea212cf4&scoped=true&"
import script from "./searchTournamentsContent.vue?vue&type=script&lang=js&"
export * from "./searchTournamentsContent.vue?vue&type=script&lang=js&"
import style0 from "./searchTournamentsContent.vue?vue&type=style&index=0&id=ea212cf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea212cf4",
  null
  
)

export default component.exports